import { AxiosResponse } from 'axios';
import { takeLatest, call, put, all, select } from 'redux-saga/effects';
import { ShipToPatientOrderConfirmation } from '../../api/types';
import { SimplyTestApi } from '../../api/simplytest';
import { selectConfig } from '../../shared/redux/slice';
import { IConfiguration } from '../../shared/types';
import { selectIdToken, unauthorized } from '../../auth/redux/slice';
import { extractErrorMessage } from '../../shared/utils';
import shipToPatientSlice, { createShipToPatientOrder } from './slice';

export abstract class ShipToPatientSagas {
    public static* run(){
        try {
            yield all([
                takeLatest(createShipToPatientOrder, ShipToPatientSagas.createShipToPatientOrder),
            ]);
        }
        catch(e: any){
            console.log(`[ShipToPatientSagas:run] the following exception has occurred`, e);
        }
    }

    private static* createShipToPatientOrder(action: ReturnType<typeof createShipToPatientOrder>){
        try {
            yield put(shipToPatientSlice.actions.setState('BUSY'));
            yield put(shipToPatientSlice.actions.setErrorMessage(undefined));
            const config: IConfiguration = yield select(selectConfig);
            const idToken: string = yield select(selectIdToken);
            const { payload } = action;

            var client = new SimplyTestApi(config.apiBaseUrl, idToken);
            const orderResponse: AxiosResponse<ShipToPatientOrderConfirmation> = yield call(
                { context: client, fn: client.createShipToPatientOrder },
                payload as any,
            );

            if(orderResponse.status === 401)
            {
                yield put(unauthorized(undefined));
                return;
            }

            if(orderResponse.status !== 200){
                const message = extractErrorMessage(orderResponse.data, 'Error placing order. Please try again.');
                yield put(shipToPatientSlice.actions.setErrorMessage(message));
                yield put(shipToPatientSlice.actions.setState('ERROR'));
                return;
            }

            yield put(shipToPatientSlice.actions.setConfirmation(orderResponse.data));
            yield put(shipToPatientSlice.actions.setState('SUCCESS'));
        }
        catch(e: any){
            yield put(shipToPatientSlice.actions.setErrorMessage('Error placing order. Please try again in a few minutes.'));
            yield put(shipToPatientSlice.actions.setState('ERROR'));
            console.log(`[ShipToPatientSagas:createShipToPatientOrder] the following exception has occurred`, e);
        }
    }
}
